import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { itemRouteBuilder, NamedRts } from "@/router";
import { JSConn } from "@/utilities/js-conn";
import { inventoryLotsController } from "@/controllers/inventoryLots";
import { InventoryLot } from "@/models/InventoryLot";

export default defineComponent({
  name: "inventoryLotPrint",
  props: {
    inventoryLotId: {
      type: String,
      required: true,
    },
  },
  components: {
    LoadingAnimation,
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage = ref("Loading Inventory Lot...");

    const showRouteBuilder = () => {
      return itemRouteBuilder(
        NamedRts.inventoryLotDetails,
        props.inventoryLotId,
      );
    };

    onMounted(() => {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: props.inventoryLotId,
      };

      Promise.all([inventoryLotsController.needInventoryLot(jsConn)]).finally(
        () => {
          dataLoaded.value = true;
        },
      );
    });

    const inventoryLot = computed(() => {
      return $store.getters.inventoryLot as InventoryLot;
    });

    return {
      inventoryLot,

      dataLoaded,
      loadingMessage,
      showRouteBuilder,
    };
  },
});
